import {classNames, React, observer} from '@api'
import {GroupByGroupStoreContext, IGroupByQueryManagerResult, CardStack, GroupByGroupStore, GroupSummaryCard, useGroupByRootStore, GroupByGroupHeaderStacked} from '@modules'
import {useVipLocalStore} from '@modules'
import * as css from './StackedGroups.css'

export const StackedGroups = observer<{ className?: string, index: number, groups: Array<IGroupByQueryManagerResult> }>(({className, index, groups}) => {
  const rootStore = useGroupByRootStore(),
    {groupName} = rootStore,
    store = useVipLocalStore((ws) => new GroupByGroupStore(
      ws,
      {
        groupCount: rootStore.mgr.groupCount,
        level: 0, groupName, path: [],
        group: index.toString(), info: {
          title: rootStore.groupTitle,
          id: groupName,
          key: groupName,
          count: _.sum(groups.map(g => g.count))
        }
      })),
    {settings: {stackView}} = store
  /*
    Join the values and put it in the header instead of the label
  */
  return <GroupByGroupStoreContext.Provider value={store}>
    <div className={classNames(css.root, className)}>
      <GroupByGroupHeaderStacked showButtons/>
      <CardStack stackView={stackView}
                 className={css.groupSummaryStack}
                 orientation={false ? 'horizontal' : 'vertical'}
                 count={groups.length}
                 renderCard={i => {
                   const g = groups[i]
                   return <GroupSummaryCard key={g.key} group={g}/>
                 }}/>
    </div>
  </GroupByGroupStoreContext.Provider>
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/StackedGroups.tsx